import React from 'react';
import { cn } from '../../lib/utils';

const Spinner = React.forwardRef(({ className, size = "default", variant = "default", ...props }, ref) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6", 
    lg: "h-8 w-8",
    xl: "h-12 w-12"
  };

  const variantClasses = {
    default: "border-gray-300 border-t-blue-600",
    white: "border-gray-400 border-t-white",
    primary: "border-gray-300 border-t-primary",
    secondary: "border-gray-300 border-t-secondary"
  };

  return (
    <div
      ref={ref}
      className={cn(
        "animate-spin rounded-full border-2",
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
});

Spinner.displayName = "Spinner";

export { Spinner }; 